import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { FormattedMessage } from 'react-intl';

import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiTypography from '@material-ui/core/Typography';

import PropTypes from 'prop-types';
import ArrowIcon from '../Icons/Arrow/ArrowIcon';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    marginLeft: 60,
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);


const Typography = withStyles({
  root: {
    width: '100%',
  },
})(MuiTypography);

const useStyle = makeStyles(() => ({
  contentWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

const CustomExpansionPanel = (
  { id,
    isNew,
    text,
    children,
    active,
    editable,
    setEditable,
    expandedState,
    handler = () => {} }) => {
  const classes = useStyle();
  const info = text && text.texts ? text.texts.join(' ') : '';

  return (
    <React.Fragment>
      <ExpansionPanel
        expanded={active}
        onChange={(event, expanded) => {
          handler(id, expanded);
        }}
      >
        <ExpansionPanelSummary>
          <div className={classes.contentWrapper}>
            <Typography>
              <FormattedMessage id={text.title} />{info && ` ${info}`}
            </Typography>
            <ArrowIcon
              id={id}
              actualState={active}
              isNew={isNew}
              title={text.icon}
              editable={editable}
              setEditable={setEditable}
              expandedState={expandedState}
            />
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </React.Fragment>
  );
};

CustomExpansionPanel.propTypes = {
  id: PropTypes.number,
  editable: PropTypes.bool,
  setEditable: PropTypes.func,
  text: PropTypes.object,
  children: PropTypes.node,
  active: PropTypes.bool,
  handler: PropTypes.func,
  isNew: PropTypes.bool,
  expandedState: PropTypes.bool,
};

export default CustomExpansionPanel;
